// extracted by css-extract-rspack-plugin
export default {"input":"_29c09db","inputWrapper":"_16647568","button":"_c3b6d17b","error":"_2fc465d5"};